// 3rd party imports
import * as React from 'react';

// ui
import { LocalizedText } from '@shared-ui/localization-context';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkLink } from 'uitk-react-link';
import { UitkList, UitkListItem } from 'uitk-react-list';

// utils
import { useStores, useLocaleParam } from 'hooks';
import { getUserAnalyticsMicroMessage } from '../../util/analytics';

function Flows() {
  const { analytics, userAuth, pzStore } = useStores();

  const { signupLink } = useLocaleParam();

  const referrerId = 'affhub_home_join_now_link.selected';
  const linkName = 'AffHub Home Join Now Link Selected';

  const trackSelect = {
    id: referrerId,
    callback: () => {
      if (analytics && typeof analytics.trackEvent === 'function') {
        analytics.trackEvent(referrerId, linkName, null, null, true, [
          getUserAnalyticsMicroMessage(userAuth?.currentUserDetails, pzStore?.pzPublisher),
        ]);
      }
    },
  };

  return (
    <div className="Flows container">
      <UitkSpacing padding={{ blockend: 'twelve' }}>
        <div>
          <UitkSpacing padding={{ blockend: 'four' }}>
            <UitkHeading tag="h2" size={3}>
              <LocalizedText message="home.flows.heading.how_our_program_works" />
            </UitkHeading>
          </UitkSpacing>
          <UitkText>
            <LocalizedText message="home.flows.content.use_tools_drive_traffic" />
          </UitkText>
        </div>
      </UitkSpacing>
      <UitkList type="ordered" orientation="inline" className="Flows__list">
        <UitkListItem>
          <UitkSpacing padding={{ blockend: 'two' }}>
            <UitkHeading tag="h3" size={4}>
              <LocalizedText message="home.flows.subheading.join" />
            </UitkHeading>
          </UitkSpacing>
          <UitkText size={300}>
            <LocalizedText message="home.flows.content.apply_to_join" />
          </UitkText>
          <UitkSpacing padding={{ blockstart: 'two' }}>
            <UitkLink analytics={trackSelect}>
              <a href={signupLink}>
                <LocalizedText message="common.join_now" />
              </a>
            </UitkLink>
          </UitkSpacing>
        </UitkListItem>
        <UitkListItem>
          <UitkSpacing padding={{ blockend: 'two' }}>
            <UitkHeading tag="h3" size={4}>
              <LocalizedText message="home.flows.subheading.share" />
            </UitkHeading>
          </UitkSpacing>
          <UitkText size={300}>
            <LocalizedText message="home.flows.content.use_our_tools" />
          </UitkText>
        </UitkListItem>
        <UitkListItem>
          <UitkSpacing padding={{ blockend: 'two' }}>
            <UitkHeading tag="h3" size={4}>
              <LocalizedText message="home.flows.subheading.earn" />
            </UitkHeading>
          </UitkSpacing>
          <UitkText size={300}>
            <LocalizedText message="home.flows.content.earning" />
          </UitkText>
        </UitkListItem>
      </UitkList>
    </div>
  );
}

export { Flows };
